import React, { useState, useCallback } from 'react';

import { ModalTransition } from '@atlaskit/modal-dialog';

import { preloadProfileMenu } from '@confluence/nav-menus/entry-points/preloadProfileMenu';
import { AccountMenu } from '@confluence/nav-menus/entry-points/AccountMenu';

import type { TopNavigationQuery$data } from './__generated__/TopNavigationQuery.graphql';

type AccountButtonProps = {
	user: NonNullable<TopNavigationQuery$data['user']>;
};

export const AccountButton = ({ user }: AccountButtonProps) => {
	const [activeDialog, setActiveDialog] = useState(null);

	const closeDialog = useCallback(() => {
		setActiveDialog(null);
	}, [setActiveDialog]);

	const openDialog = useCallback(
		(dialog: any) => {
			setActiveDialog(dialog(closeDialog));
		},
		[setActiveDialog, closeDialog],
	);

	const preloadMenu = useCallback(() => {
		void preloadProfileMenu();
	}, []);

	// Convert Relay generated type to AccountMenu's expected User type
	const accountMenuUser = {
		id: user.id ?? null,
		displayName: user.displayName ?? null,
		emails: user.emails?.map((email) => ({ value: email?.value || null })) || null,
		photos: user.photos?.map((photo) => ({ value: photo?.value || null })) || null,
	};

	return (
		<>
			<div onMouseEnter={preloadMenu} onFocus={preloadMenu}>
				<AccountMenu user={accountMenuUser} dialogFn={openDialog} />
			</div>
			<ModalTransition>{activeDialog}</ModalTransition>
		</>
	);
};
